module.exports = __webpack_public_path__ + "images/decorator-small-b71fc2.svg";